import React, { useState } from 'react'

import { Box, Button, Grid } from '@material-ui/core'
import { HelpCircle as HelpCircleIcon } from 'react-feather'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'

import { Container, ContentHeader, Page } from 'components'
import { CreationForm, ImportForm } from './components'

import ThirdPartyManagementStepperProvider from 'providers/ThirdPartyManagementStepperProvider'

import constants from 'constants/index'
import theme from 'theme'

const ThirdPartyManagementMySuppliersNew = () => {
  const registerTypes = constants.thirdPartyManagements.REGISTER_TYPES
  const location = useLocation()
  const query = qs.parse(location.search)

  const isPreAvaliation = !!query.preAvaliation

  const [openTour, setOpenTour] = useState(false)
  const [activeStep, setActiveStep] = useState(0)
  const [registerType, setRegisterType] = useState(
    query.registerType || registerTypes.REGISTER,
  )

  const showRegisterForm = [
    registerTypes.REGISTER,
    registerTypes.PRE_AVALIATION,
  ].includes(registerType)

  const { STEPS } = constants.tours.thirdPartyManagements
  const importTourStepIds = isPreAvaliation
    ? STEPS.PRE_AVALIATION.CREATION.IMPORT
    : STEPS.CREATION.IMPORT

  const handleOpenTour = () => setOpenTour(true)
  const handleImport = () => {
    if (registerType === registerTypes.IMPORT) {
      setRegisterType(registerTypes.REGISTER)
    } else {
      setRegisterType(registerTypes.IMPORT)
    }
  }

  return (
    <Page
      title={`Gestão de Fornecedores - Cadastrar ${
        isPreAvaliation ? 'Pré-Avaliado' : 'Fornecedor'
      }`}
    >
      <Container maxWidth={false}>
        <ContentHeader
          title={`Cadastrar ${isPreAvaliation ? 'Pré-Avaliado' : 'Fornecedor'}`}
          preserveSearch
        >
          <Box display="flex" gridGap={theme.spacing(1)}>
            <Button
              id={
                registerType === registerTypes.IMPORT
                  ? importTourStepIds[1]
                  : undefined
              }
              variant="contained"
              color="primary"
              startIcon={<HelpCircleIcon size={20} />}
              onClick={handleOpenTour}
            >
              Tutorial
            </Button>

            <Button variant="contained" color="primary" onClick={handleImport}>
              {showRegisterForm
                ? `Importar ${
                    isPreAvaliation ? 'Pré-Avaliados' : 'Fornecedores'
                  }`
                : `Cadastrar ${
                    isPreAvaliation ? 'Pré-Avaliado' : 'Fornecedor'
                  }`}
            </Button>
          </Box>
        </ContentHeader>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            {showRegisterForm ? (
              <ThirdPartyManagementStepperProvider
                isPreAvaliation={isPreAvaliation}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
              >
                <CreationForm openTour={openTour} setOpenTour={setOpenTour} />
              </ThirdPartyManagementStepperProvider>
            ) : (
              <ImportForm
                isPreAvaliation={isPreAvaliation}
                openTour={openTour}
                setOpenTour={setOpenTour}
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </Page>
  )
}

export default ThirdPartyManagementMySuppliersNew
